import { UserInformation } from './user-information';
import {
  loadUserInformation,
  loadUserInformationSuccess,
  resetUserInformation,
  updateAccountsList,
  updateSelectedAccountNumber,
  updateSelectedSubscriberNo,
  updateUserInformation,
} from './actions';
import { Action, createReducer, on } from '@ngrx/store';

const initialState: UserInformation = {};

const createUserInformationReducer = createReducer(
  initialState,
  on(loadUserInformation, state => state),
  on(loadUserInformationSuccess, (_state, { userInfo }) => userInfo),
  on(resetUserInformation, _state => initialState),
  on(updateAccountsList, (state, { accounts }) => ({ ...state, accounts })),
  on(updateSelectedAccountNumber, (state, { accountNumber }) => ({
    ...state,
    selectedAccountNumber: accountNumber.toString(),
  })),
  on(updateSelectedSubscriberNo, (state, { subscriberNo }) => ({ ...state, selectedSubscriberNo: subscriberNo })),
  on(updateUserInformation, (_state, { userInfo }) => ({ ...userInfo })),
);

// eslint-disable-next-line
export function userInformationReducer(state: UserInformation, action: Action) {
  return createUserInformationReducer(state, action);
}
